module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cost-centers",
    class: {
      'cost-centers-container': _vm.isInSchoolSalarySettings
    }
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": _vm.isInSchoolSalarySettings ? '#edf0f5' : '#fff'
    }
  }) : [_c('table', {
    staticClass: "do-table do-table__items do-table--striped"
  }, [_c('thead', [_c('th', [_vm._v("Kode")]), _vm._v(" "), _c('th', [_vm._v("Omkostningssted")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60%"
    }
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.setIsCreateItemModal(true)
      }
    }
  }, [_vm._v("\n          Opret omkostningssted\n        ")])])]), _vm._v(" "), _c('tbody', [(_vm.costCenters.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('i', [_vm._v("Ingen oprettet")])]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.costCenters), function(cc) {
    return _c('CostCentersCenter', {
      key: cc.id,
      attrs: {
        "item": cc,
        "calendars": _vm.calendars,
        "calendarNames": _vm.calendarNames,
        "initialSelectedCalendarIds": _vm.getInitialIdsFor(cc.id),
        "isInSchoolSalarySettings": _vm.isInSchoolSalarySettings,
        "isUpdating": _vm.updatingCostCenterId === cc.id
      },
      on: {
        "save": _vm.onSaveRule,
        "archive": _vm.archiveCostCenter
      }
    })
  })], 2)]), _vm._v(" "), (_vm.archivedCostCenters.length > 0) ? _c('p', {
    staticClass: "text-link marg-1-top",
    on: {
      "click": function($event) {
        _vm.isShowArchived = !_vm.isShowArchived
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.isShowArchived ? 'Skjul arkiverede' : 'Vis arkiverede') + "\n      " + _vm._s('(' + _vm.archivedCostCenters.length + ')') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isShowArchived && _vm.archivedCostCenters.length > 0) ? _c('table', {
    staticClass: "do-table do-table__items do-table--striped marg-1-top"
  }, [_c('thead', [_c('th', [_vm._v("Kode")]), _vm._v(" "), _c('th', [_vm._v("Omkostningssted")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60%"
    }
  })]), _vm._v(" "), _c('tbody', _vm._l((_vm.archivedCostCenters), function(cc) {
    return _c('CostCentersCenter', {
      key: cc.id,
      attrs: {
        "item": cc,
        "calendars": _vm.calendars,
        "calendarNames": _vm.calendarNames,
        "initialSelectedCalendarIds": _vm.getInitialIdsFor(cc.id),
        "isInSchoolSalarySettings": _vm.isInSchoolSalarySettings,
        "isUpdating": _vm.updatingCostCenterId === cc.id
      },
      on: {
        "save": _vm.onSaveRule,
        "archive": _vm.archiveCostCenter
      }
    })
  }), 1)]) : _vm._e()], _vm._v(" "), (_vm.isCreateItemModal) ? _c('TableCreateModal', {
    attrs: {
      "theType": 'omkostningssteder',
      "theEditItem": _vm.theEditItem,
      "isSubmitting": _vm.isSubmitting,
      "isDeleting": _vm.isDeleting
    },
    on: {
      "onSubmit": _vm.onCreate,
      "close": _vm.setIsCreateItemModal
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68922777!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SchoolSettings/CostCenters.vue
// module id = 1977
// module chunks = 1